"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Size = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ChevronDown_1 = __importDefault(require("../Icons/ChevronDown/ChevronDown"));
var Plus_1 = __importStar(require("../Icons/Plus/Plus"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var Typography_1 = __importStar(require("../Typography/Typography"));
var CheckmarkRounded_1 = __importStar(require("../Icons/CheckmarkRounded/CheckmarkRounded"));
var Size;
(function (Size) {
    Size["small"] = "small";
    Size["default"] = "default";
})(Size = exports.Size || (exports.Size = {}));
var SelectElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  position: relative;\n"], ["\n  display: block;\n  position: relative;\n"])));
var SelectContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: ", ";\n  opacity: ", ";\n  outline: none;\n  padding: 3rem 2.4rem 1.6rem 2.4rem;\n  background: ", ";\n  border: ", ";\n\n  &:focus {\n    border: ", ";\n  }\n"], ["\n  font-family: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: ", ";\n  opacity: ", ";\n  outline: none;\n  padding: 3rem 2.4rem 1.6rem 2.4rem;\n  background: ", ";\n  border: ", ";\n\n  &:focus {\n    border: ", ";\n  }\n"])), b2c_theme_1.fonts.defaultMedium, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.8 : 1);
}, b2c_theme_1.colors.input.background, function (_a) {
    var invalid = _a.invalid;
    return invalid
        ? "2px solid ".concat(b2c_theme_1.colors.form.invalid)
        : "2px solid ".concat(b2c_theme_1.colors.input.background);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled
        ? "2px solid ".concat(b2c_theme_1.colors.white)
        : "2px solid ".concat(b2c_theme_1.colors.outlineFocusColor);
});
var LabelElement = styled_components_1.default.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: 2.8rem;\n  top: ", ";\n  font-size: 1.2rem;\n  text-transform: uppercase;\n\n  color: ", ";\n"], ["\n  position: absolute;\n  left: 2.8rem;\n  top: ", ";\n  font-size: 1.2rem;\n  text-transform: uppercase;\n\n  color: ", ";\n"])), function (_a) {
    var compact = _a.compact;
    return (compact ? '1.1rem' : '1.7rem');
}, function (_a) {
    var invalid = _a.invalid;
    return invalid ? b2c_theme_1.colors.input.invalid : b2c_theme_1.colors.labelFontColor;
});
var Popover = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: ", ";\n  position: absolute;\n  top: 100%;\n  margin-top: ", ";\n  outline: none;\n  min-width: 260px;\n  background: transparent;\n"], ["\n  display: ", ";\n  position: absolute;\n  top: 100%;\n  margin-top: ", ";\n  outline: none;\n  min-width: 260px;\n  background: transparent;\n"])), function (_a) {
    var open = _a.open;
    return (open ? 'block' : 'none');
}, function (_a) {
    var withGrouping = _a.withGrouping;
    return (withGrouping ? '0' : '10px');
});
var PopoverContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  z-index: 100;\n  width: 100%;\n  background: ", ";\n  position: relative;\n  margin-top: 10px;\n  border-radius: ", ";\n  box-shadow: ", ";\n"], ["\n  width: 100%;\n  z-index: 100;\n  width: 100%;\n  background: ", ";\n  position: relative;\n  margin-top: 10px;\n  border-radius: ", ";\n  box-shadow: ", ";\n"])), b2c_theme_1.colors.white, b2c_theme_1.borders.defaultBorderRadius, b2c_theme_1.popover.boxShadow);
var PopoverOption = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 1rem 1.3rem;\n  ", ";\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  ", ";\n\n  &:first-of-type {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      left: calc(50% - 3px);\n      bottom: 100%;\n      width: 0;\n      height: 0;\n      border: 6px solid transparent;\n      border-bottom-color: ", ";\n    }\n  }\n\n  &:last-of-type {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n    ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  padding: 1rem 1.3rem;\n  ", ";\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  ", ";\n\n  &:first-of-type {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      left: calc(50% - 3px);\n      bottom: 100%;\n      width: 0;\n      height: 0;\n      border: 6px solid transparent;\n      border-bottom-color: ", ";\n    }\n  }\n\n  &:last-of-type {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n    ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var active = _a.active;
    return active
        ? "border: 1px solid ".concat(b2c_theme_1.colors.outlineFocusColor)
        : "\n        border: 1px solid ".concat(b2c_theme_1.colors.white, ";\n        border-bottom: 1px solid ").concat(b2c_theme_1.colors.dividerColor, ";\n      ");
}, function (_a) {
    var isAddOption = _a.isAddOption;
    return !isAddOption && "  justify-content: space-between";
}, b2c_theme_1.borders.defaultBorderRadius, b2c_theme_1.borders.defaultBorderRadius, b2c_theme_1.colors.white, b2c_theme_1.borders.defaultBorderRadius, b2c_theme_1.borders.defaultBorderRadius, function (_a) {
    var active = _a.active;
    return !active && "border-bottom: 2px solid ".concat(b2c_theme_1.colors.white, ";");
}, b2c_theme_1.colors.defaultHoverBackground);
var GroupedPopoverOption = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  padding: 0.8rem 1.3rem;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  ", ";\n  padding: 0.8rem 1.3rem;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var active = _a.active;
    return active
        ? "border: 1px solid ".concat(b2c_theme_1.colors.outlineFocusColor)
        : "border: 1px solid ".concat(b2c_theme_1.colors.white, ";");
}, b2c_theme_1.colors.white, b2c_theme_1.colors.defaultHoverBackground);
var TextStack = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 0 2rem 0 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 0 2rem 0 0;\n"])));
var IconContainer = styled_components_1.default.i(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  min-width: 22px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  min-width: 22px;\n"])));
var GroupedOptionsWrapper = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  max-height: 300px;\n  overflow-y: auto;\n"], ["\n  display: flex;\n  flex-direction: column;\n  max-height: 300px;\n  overflow-y: auto;\n"])));
var GroupedOptionsGroupWrapper = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var GroupHeaderContainer = styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  position: sticky;\n  top: 0;\n  padding: 1.4rem 1.5rem 0.8rem 1.5rem;\n  background-color: ", ";\n"], ["\n  position: sticky;\n  top: 0;\n  padding: 1.4rem 1.5rem 0.8rem 1.5rem;\n  background-color: ", ";\n"])), b2c_theme_1.colors.white);
var Select = function (props) {
    var _a;
    var defaultProps = {
        addNewOptionText: '',
        options: [],
        disabled: false,
        id: 'select',
        invalid: false,
        label: '',
        onChange: function () { },
        showAddOption: false,
        fontSize: Size.default,
    };
    var _b = __assign(__assign({}, defaultProps), props), addNewOptionText = _b.addNewOptionText, options = _b.options, disabled = _b.disabled, id = _b.id, invalid = _b.invalid, label = _b.label, onChange = _b.onChange, onSelectAddNew = _b.onSelectAddNew, placeholder = _b.placeholder, required = _b.required, showAddOption = _b.showAddOption, defaultValue = _b.defaultValue, defaultGroup = _b.defaultGroup, defaultGroupOption = _b.defaultGroupOption, fontSize = _b.fontSize, groupedOptions = _b.groupedOptions;
    var formattedOptions = (0, react_1.useMemo)(function () {
        return options.map(function (option) {
            return {
                subtext: option.subtext,
                label: option.label,
                key: option.value,
                value: option.value,
            };
        });
    }, [options]);
    var formattedGroupedOptions = (0, react_1.useMemo)(function () {
        return groupedOptions === null || groupedOptions === void 0 ? void 0 : groupedOptions.map(function (group) {
            return {
                label: group.label,
                options: group.options.map(function (option) {
                    return {
                        label: option.label,
                        value: option.value,
                        id: option.id,
                    };
                }),
            };
        });
    }, [groupedOptions]);
    var _c = (0, react_1.useState)(0), active = _c[0], setActive = _c[1];
    var _d = (0, react_1.useState)((defaultValue &&
        formattedOptions.find(function (option) { return option.value === defaultValue; })) ||
        undefined), selected = _d[0], setSelected = _d[1];
    var _e = (0, react_1.useState)(false), isSelectOpen = _e[0], setIsSelectOpen = _e[1];
    var listBox = (0, react_1.useRef)(null);
    var comboBox = (0, react_1.useRef)(null);
    var initialMount = (0, react_1.useRef)(true);
    var _f = (0, react_1.useState)(Typography_1.TypeVariants.bodyXLarge), textSize = _f[0], setTextSize = _f[1];
    var _g = (0, react_1.useState)(((formattedGroupedOptions === null || formattedGroupedOptions === void 0 ? void 0 : formattedGroupedOptions.length) &&
        defaultGroup &&
        parseInt(defaultGroup)) ||
        undefined), selectedGroup = _g[0], setSelectedGroup = _g[1];
    var _h = (0, react_1.useState)((formattedGroupedOptions &&
        defaultGroup &&
        defaultGroupOption &&
        ((_a = formattedGroupedOptions[parseInt(defaultGroup)]) === null || _a === void 0 ? void 0 : _a.options.findIndex(function (option) { return option.id === defaultGroupOption; }))) ||
        undefined), selectedGroupOption = _h[0], setSelectedGroupOption = _h[1];
    var _j = (0, react_1.useState)(0), activeGroup = _j[0], setActiveGroup = _j[1];
    var _k = (0, react_1.useState)(0), activeGroupOption = _k[0], setActiveGroupOption = _k[1];
    var _l = (0, react_1.useState)(false), grouped = _l[0], setGrouped = _l[1];
    var _m = (0, react_1.useState)(null), selectedGroupOptionLabel = _m[0], setSelectedGroupOptionLabel = _m[1];
    var _o = (0, react_1.useState)(0), maxGroupIndex = _o[0], setMaxGroupIndex = _o[1];
    var _p = (0, react_1.useState)(0), maxGroupOptionIndex = _p[0], setMaxGroupOptionIndex = _p[1];
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (groupedOptions && groupedOptions.length) {
            setGrouped(true);
            setMaxGroupIndex(groupedOptions.length - 1);
            setMaxGroupOptionIndex(((_b = (_a = groupedOptions[0]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.length) - 1);
            setSelectedGroupOptionLabel(null);
            setSelectedGroup(undefined);
            setSelectedGroupOption(undefined);
            setActiveGroup(0);
            setActiveGroupOption(0);
        }
        else {
            setGrouped(false);
        }
    }, [groupedOptions]);
    (0, react_1.useEffect)(function () {
        if (fontSize === Size.small) {
            setTextSize(Typography_1.TypeVariants.h5);
            return;
        }
        setTextSize(Typography_1.TypeVariants.bodyXLarge);
    }, [fontSize]);
    (0, react_1.useEffect)(function () {
        if (defaultValue) {
            setSelected(formattedOptions.find(function (option) { return option.value === defaultValue; }) ||
                formattedOptions[0]);
        }
        else {
            setSelected(undefined);
            setActive(0);
        }
    }, [options, defaultValue]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (defaultGroup && defaultGroupOption) {
            setSelectedGroup(parseInt(defaultGroup));
            setSelectedGroupOption(formattedGroupedOptions &&
                ((_a = formattedGroupedOptions[parseInt(defaultGroup)]) === null || _a === void 0 ? void 0 : _a.options.findIndex(function (option) { return option.id === defaultGroupOption; })));
        }
    }, [formattedGroupedOptions, defaultGroup, defaultGroupOption]);
    (0, react_1.useEffect)(function () {
        if (selected) {
            setActive(formattedOptions.findIndex(function (option) { return option.value === selected.value; }));
            if (onChange && !initialMount.current) {
                onChange(selected.value);
            }
        }
        initialMount.current = false;
    }, [selected]);
    (0, react_1.useEffect)(function () {
        if (isSelectOpen) {
            document.addEventListener('click', handleClickOutside, true);
        }
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [isSelectOpen]);
    (0, react_1.useEffect)(function () {
        if (formattedGroupedOptions &&
            formattedGroupedOptions.length &&
            selectedGroup !== undefined &&
            selectedGroupOption !== undefined) {
            var group = formattedGroupedOptions[selectedGroup];
            var option = group.options[selectedGroupOption];
            setSelectedGroupOptionLabel("".concat(group.label, ": ").concat(option === null || option === void 0 ? void 0 : option.label));
            setActiveGroup(selectedGroup);
            setActiveGroupOption(selectedGroupOption);
        }
    }, [selectedGroup, selectedGroupOption]);
    (0, react_1.useEffect)(function () {
        if (formattedGroupedOptions &&
            formattedGroupedOptions.length &&
            selectedGroup !== undefined &&
            selectedGroupOption !== undefined) {
            var group = formattedGroupedOptions[selectedGroup];
            var option = group.options[selectedGroupOption];
            if (onChange && !initialMount.current) {
                if (option && option.value)
                    onChange(option.value);
            }
        }
        initialMount.current = false;
    }, [selectedGroupOption]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (formattedGroupedOptions)
            setMaxGroupOptionIndex(((_b = (_a = formattedGroupedOptions[activeGroup]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.length) - 1);
    }, [activeGroup, activeGroupOption]);
    var handleClickOutside = function (event) {
        if (listBox.current && !listBox.current.contains(event.target)) {
            setIsSelectOpen(false);
        }
    };
    var closeListBox = function () {
        setIsSelectOpen(false);
    };
    var openListBox = function () {
        if (!disabled) {
            setIsSelectOpen(true);
        }
    };
    var onClickOption = function (event, index) {
        event.stopPropagation();
        setSelected(formattedOptions[index]);
        if (comboBox === null || comboBox === void 0 ? void 0 : comboBox.current) {
            comboBox.current.focus();
        }
        closeListBox();
    };
    var onClickGroupOption = function (event, group, option) {
        event.stopPropagation();
        setSelectedGroup(group);
        setSelectedGroupOption(option);
        if (comboBox === null || comboBox === void 0 ? void 0 : comboBox.current) {
            comboBox.current.focus();
        }
        closeListBox();
    };
    var isGroupOptionSelected = function (group, index) {
        return selectedGroup === group && selectedGroupOption === index;
    };
    var isGeroupOptionsActive = function (group, index) {
        return activeGroup === group && activeGroupOption === index;
    };
    var scrollListIntoView = function () {
        var listbox = listBox.current;
        var activeOption = listbox === null || listbox === void 0 ? void 0 : listbox.querySelector("[data-testid=\"select-listbox-option\"][data-isactive=\"true\"]");
        if (activeOption && typeof activeOption.scrollIntoView === 'function') {
            activeOption.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    };
    var navigateFlatList = function (event) {
        var maxIndex = showAddOption
            ? formattedOptions.length
            : formattedOptions.length - 1;
        switch (event.code) {
            case 'ArrowDown':
                if (isSelectOpen) {
                    setActive(Math.min(maxIndex, active + 1));
                }
                else {
                    openListBox();
                }
                break;
            case 'ArrowUp':
                if (isSelectOpen) {
                    setActive(Math.max(0, active - 1));
                }
                else {
                    openListBox();
                }
                break;
            case 'Escape':
                if (isSelectOpen) {
                    closeListBox();
                }
                break;
            case 'Enter':
            case 'Space':
                if (isSelectOpen) {
                    if (showAddOption && active === formattedOptions.length) {
                        if (onSelectAddNew) {
                            onSelectAddNew(event);
                        }
                        setActive(formattedOptions.findIndex(function (option) { return option.value === (selected === null || selected === void 0 ? void 0 : selected.value); }));
                        closeListBox();
                    }
                    else {
                        setSelected(formattedOptions[active]);
                        closeListBox();
                    }
                }
                else {
                    openListBox();
                }
                break;
            case 'Home':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActive(0);
                break;
            case 'End':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActive(maxIndex);
                break;
            case 'PageUp':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActive(Math.max(0, active - 10));
                break;
            case 'PageDown':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActive(Math.min(maxIndex, active + 10));
                break;
            case 'Tab':
                setSelected(formattedOptions[active]);
                closeListBox();
                break;
        }
    };
    var navigateGroupList = function (event) {
        var _a;
        event.preventDefault();
        switch (event.code) {
            case 'ArrowDown':
                if (isSelectOpen) {
                    if (activeGroupOption === maxGroupOptionIndex &&
                        activeGroup === maxGroupIndex) {
                        return;
                    }
                    setActiveGroupOption(Math.min(maxGroupOptionIndex, activeGroupOption + 1));
                    if (activeGroupOption === maxGroupOptionIndex) {
                        setActiveGroup(Math.min(maxGroupIndex, activeGroup + 1));
                        setActiveGroupOption(0);
                    }
                }
                else {
                    openListBox();
                }
                break;
            case 'ArrowUp':
                if (isSelectOpen) {
                    if (activeGroupOption === 0 && activeGroup === 0) {
                        return;
                    }
                    setActiveGroupOption(Math.max(0, activeGroupOption - 1));
                    if (activeGroupOption === 0) {
                        setActiveGroup(Math.max(0, activeGroup - 1));
                        formattedGroupedOptions &&
                            setActiveGroupOption(((_a = formattedGroupedOptions[Math.max(0, activeGroup - 1)]) === null || _a === void 0 ? void 0 : _a.options.length) - 1);
                    }
                }
                else {
                    openListBox();
                }
                break;
            case 'Escape':
                if (isSelectOpen) {
                    closeListBox();
                }
                break;
            case 'Tab':
            case 'Enter':
            case 'Space':
                if (isSelectOpen) {
                    setSelectedGroup(activeGroup);
                    setSelectedGroupOption(activeGroupOption);
                    closeListBox();
                }
                else {
                    openListBox();
                }
                break;
            case 'Home':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActiveGroup(0);
                setActiveGroupOption(0);
                break;
            case 'End':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActiveGroup(maxGroupIndex);
                setActiveGroupOption(maxGroupOptionIndex);
                break;
            case 'PageUp':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActiveGroup(Math.max(0, activeGroup - 1));
                setActiveGroupOption(0);
                break;
            case 'PageDown':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActiveGroup(Math.min(maxGroupIndex, activeGroup + 1));
                setActiveGroupOption(0);
                break;
        }
    };
    var onNavigateList = function (event) {
        if (grouped) {
            navigateGroupList(event);
            scrollListIntoView();
        }
        else {
            navigateFlatList(event);
        }
    };
    return (react_1.default.createElement(SelectElement, { "data-testid": "select" },
        react_1.default.createElement(LabelElement, { htmlFor: id, invalid: invalid, compact: fontSize === Size.small, "data-testid": "select-label-element" },
            label,
            required ? (react_1.default.createElement(Typography_1.default, { component: Typography_1.TypeVariants.span, variant: Typography_1.TypeVariants.bodySmall, theme: "invalid", style: { lineHeight: 1 } }, "\u00A0*\u00A0")) : null),
        react_1.default.createElement(SelectContainer, { "data-testid": "select-combobox", "aria-controls": "".concat(id, "-combo-listbox"), "aria-disabled": disabled, "aria-haspopup": "listbox", "aria-expanded": isSelectOpen, "aria-activedescendant": isSelectOpen
                ? grouped
                    ? "".concat(id, "-combo-listbox-option-").concat(activeGroup, "-").concat(activeGroupOption)
                    : "".concat(id, "-combo-listbox-option-").concat(active)
                : undefined, "aria-label": label, id: id, invalid: invalid, role: "combobox", tabIndex: 0, disabled: !!disabled, onClick: openListBox, onKeyDown: onNavigateList, onFocus: openListBox, ref: comboBox },
            react_1.default.createElement(TextStack, null, grouped ? (react_1.default.createElement(react_1.default.Fragment, null, selectedGroupOptionLabel ? (react_1.default.createElement(Typography_1.default, { variant: textSize, component: Typography_1.TypeVariants.span, margin: "0 2rem 0 0", theme: "darkTitle", "data-testid": "select-grouped-selected-option" }, selectedGroupOptionLabel)) : (react_1.default.createElement(Typography_1.default, { variant: textSize, component: Typography_1.TypeVariants.span, margin: "0 2rem 0 0", theme: "secondary" }, placeholder)))) : (react_1.default.createElement(react_1.default.Fragment, null, selected ? (react_1.default.createElement(Typography_1.default, { variant: textSize, component: Typography_1.TypeVariants.span, margin: "0 2rem 0 0", theme: "darkTitle" }, selected.label)) : (react_1.default.createElement(Typography_1.default, { variant: textSize, component: Typography_1.TypeVariants.span, margin: "0 2rem 0 0", theme: "secondary" }, placeholder))))),
            disabled ? null : (react_1.default.createElement(IconContainer, null,
                react_1.default.createElement(ChevronDown_1.default, null)))),
        react_1.default.createElement(Popover, { "data-testid": "select-listbox", id: "".concat(id, "-combo-listbox"), open: isSelectOpen, tabIndex: -1, role: "listbox", ref: listBox, withGrouping: grouped },
            react_1.default.createElement(PopoverContainer, null,
                (formattedOptions === null || formattedOptions === void 0 ? void 0 : formattedOptions.length)
                    ? formattedOptions.map(function (option, index) { return (react_1.default.createElement(PopoverOption, { active: active === index, "data-isactive": active === index, "data-testid": "select-listbox-option", id: "".concat(id, "-combo-listbox-option-").concat(index), key: option.key, role: "option", "data-value": option.value, "aria-selected": option.value === (selected === null || selected === void 0 ? void 0 : selected.value), onClick: function (event) { return onClickOption(event, index); } },
                        react_1.default.createElement(TextStack, null,
                            react_1.default.createElement(Typography_1.default, { variant: Typography_1.TypeVariants.bodyLarge, component: Typography_1.TypeVariants.span, margin: "0 2rem 0 0", theme: "darkTitle" }, option.label),
                            react_1.default.createElement(Typography_1.default, { variant: Typography_1.TypeVariants.bodySmall, component: Typography_1.TypeVariants.span, margin: "0 2rem 0 0", theme: "secondary" }, option.subtext)),
                        option.value === (selected === null || selected === void 0 ? void 0 : selected.value) && (react_1.default.createElement(IconContainer, { "data-testid": "select-selected-icon" },
                            react_1.default.createElement(CheckmarkRounded_1.default, { color: CheckmarkRounded_1.IconColorThemes.green, size: b2c_theme_1.IconSizes.small }))))); })
                    : null,
                showAddOption && !grouped && (react_1.default.createElement(PopoverOption, { active: active === formattedOptions.length, isAddOption: true, "data-isactive": active === formattedOptions.length, "data-testid": "select-listbox-option", id: "".concat(id, "-combo-listbox-option-").concat(formattedOptions.length), key: 'add-new', role: "button", onClick: function (event) {
                        onSelectAddNew ? onSelectAddNew(event) : null;
                        closeListBox();
                    } },
                    react_1.default.createElement(IconContainer, null,
                        react_1.default.createElement(Plus_1.default, { size: b2c_theme_1.IconSizes.xSmall, color: Plus_1.IconColorThemes.uiDark1 })),
                    react_1.default.createElement(TextStack, null,
                        react_1.default.createElement(Typography_1.default, { variant: Typography_1.TypeVariants.bodyLarge, component: Typography_1.TypeVariants.span, margin: "0.5rem 2rem 0 0", theme: "darkTitle" }, addNewOptionText)))),
                (formattedGroupedOptions === null || formattedGroupedOptions === void 0 ? void 0 : formattedGroupedOptions.length) ? (react_1.default.createElement(GroupedOptionsWrapper, null,
                    formattedGroupedOptions.map(function (group, groupIndex) { return (react_1.default.createElement(GroupedOptionsGroupWrapper, { key: "".concat(group.label
                            .replace(' ', '-')
                            .toLowerCase(), "-").concat(groupIndex), "data-testid": "select-grouped-listbox-group" },
                        react_1.default.createElement(GroupHeaderContainer, null,
                            react_1.default.createElement(Typography_1.default, { variant: Typography_1.TypeVariants.bodySmall, component: Typography_1.TypeVariants.span, margin: "0 2rem 0 0", theme: "secondary", allCaps: true, "data-testid": "select-grouped-listbox-group-header" }, group.label)),
                        group.options.map(function (option, index) { return (react_1.default.createElement(GroupedPopoverOption, { active: isGeroupOptionsActive(groupIndex, index), "data-isactive": isGeroupOptionsActive(groupIndex, index), "data-testid": "select-listbox-option", id: "".concat(option.id, "-combo-listbox-option"), key: "".concat(group.label
                                .replace(' ', '-')
                                .toLowerCase(), "-").concat(index), role: "option", "data-value": option.value, "aria-selected": isGroupOptionSelected(groupIndex, index), onClick: function (event) {
                                return onClickGroupOption(event, groupIndex, index);
                            } },
                            react_1.default.createElement(TextStack, null,
                                react_1.default.createElement(Typography_1.default, { variant: Typography_1.TypeVariants.body, component: Typography_1.TypeVariants.span, margin: "0 2rem 0 0", theme: "darkTitle" }, option.label)),
                            isGroupOptionSelected(groupIndex, index) && (react_1.default.createElement(IconContainer, { "data-testid": "select-selected-icon" },
                                react_1.default.createElement(CheckmarkRounded_1.default, { color: CheckmarkRounded_1.IconColorThemes.green, size: b2c_theme_1.IconSizes.small }))))); }))); }),
                    showAddOption && grouped && (react_1.default.createElement(PopoverOption, { active: active === formattedGroupedOptions.length, isAddOption: true, "data-isactive": active === formattedGroupedOptions.length, "data-testid": "select-listbox-option", id: "".concat(id, "-combo-listbox-option-").concat(formattedGroupedOptions.length), key: 'add-new', role: "button", onClick: function (event) {
                            onSelectAddNew ? onSelectAddNew(event) : null;
                            closeListBox();
                        } },
                        react_1.default.createElement(IconContainer, null,
                            react_1.default.createElement(Plus_1.default, { size: b2c_theme_1.IconSizes.xSmall, color: Plus_1.IconColorThemes.uiDark1 })),
                        react_1.default.createElement(TextStack, null,
                            react_1.default.createElement(Typography_1.default, { variant: Typography_1.TypeVariants.bodyLarge, component: Typography_1.TypeVariants.span, margin: "0.5rem 2rem 0 0", theme: "darkTitle" }, addNewOptionText)))))) : null))));
};
exports.default = Select;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
//# sourceMappingURL=Select.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Select/Select.js
// module id = 1789
// module chunks = 6 15